import { render, staticRenderFns } from "./registerHome.vue?vue&type=template&id=23f1b112&scoped=true"
import script from "./registerHome.vue?vue&type=script&lang=js"
export * from "./registerHome.vue?vue&type=script&lang=js"
import style0 from "./registerHome.vue?vue&type=style&index=0&id=23f1b112&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1b112",
  null
  
)

export default component.exports